
<span i18n class="pointer" (click)="onReloadClickHandler()">
  There is a new version, click to refresh!
</span>
